import {makeAutoObservable} from "mobx";
import {IRmaReturnReason} from "../rma-types";


class RmaReturnReasonStore {
    private _model: IRmaReturnReason;
    
    constructor(model: IRmaReturnReason) {
        makeAutoObservable(this, {}, { autoBind: true});
        this._model = model;
    }
    
    public get name(): string|undefined { 
        /** there should always be a reason, but we encounted RMA without it (bug) - we don't want to crash the page when there is no reason on prod case  */
        return this._model?._internal_name; 
    }
}

export default RmaReturnReasonStore;